<template>
  <div>
    <Card>
      <Row class="search-con">
        <Col span="24">

          <label class="search-label" >分类</label>
          <Select v-model="classify_id" class="search-input" clearable> 
            <Option
              v-for="item in classifyIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <label class="search-label">平台</label>
          <Select v-model="live_id" class="search-input" clearable> 
            <Option
              v-for="item in liveIds"
              :value="item.id"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>

          <Button @click="showAddModal" type="primary" style="margin-left: 20px;">添加</Button>
        </Col>
      </Row>
      <tables
        editable
        :columns="columns"
        v-model="tableData"
        :loading="tableLoading"
      />
      <Row class="page-con">
        <div class="page-bottom">
          <Page
            :current="page"
            :total="total"
            :page-size="pageSize"
            show-sizer
            show-elevator
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </Row>
    </Card>

    <Modal
      :mask-closable="false"
      v-model="addModal"
      title="添加评论关键字"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
        ref="addCommentKeywordModal"  
       @on-ok="addSumit" @on-cancel="cancel" />
    </Modal>
    
    <Modal
      :mask-closable="false"
      v-model="editModal"
      title="修改评论关键字"
      footer-hide
      >
      <forms :resetFlag="resetFlag"
      ref="editCommentKeywordModal"  
       @on-ok="editSumit" @on-cancel="cancel" />
    </Modal>

  </div>
</template>

<script>
import Tables from "_c/tables/table-only.vue";
import Forms from "./add_comment_keyword_form.vue";
import { getCommentKeywordList, editCommentKeyword, addCommentKeyword, deleteCommentKeyword, getLiveType, getClassifys} from "@/api/data";
export default {
  name: "finance",
  components: {
    Tables,
    Forms,
  },
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      classify_id:0,
      live_id:0,
      selectId:[],
      classifyIds:[],
      liveIds:[],
      addModal: false,
      editModal: false,
      resetFlag: false,
      editData: {},
      tableLoading: true,
      allMoney: 0.0,
      startTime: "",
      endTime: "",
      columns: [ 
        {type: 'index', title: '序号',width: 100, align: "center"}, 
        { title: "关键词" , key: "keyword", editable: true },
        { title: "所属分类" , key: "classify_name", editable: true },
        { title: "所属平台" , key: "live", editable: true },
        { title: "创建时间", key: "create_time", editable: true, width: 300},
        {
          title: "Handle",
          key: "handle",width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.showEditModal(params);
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "text",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.handleDelete(params);
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      tableData: [],
    };
  },
  methods: {
    showAddModal() {
      this.addModal = true;
      this.resetFlag = !this.resetFlag;
      this.$refs.addCommentKeywordModal.setData(this.classifyIds, this.liveIds);
    },
    showEditModal(params) {
      this.editModal = true;
      this.$refs.editCommentKeywordModal.setData(this.classifyIds, this.liveIds);
      this.$refs.editCommentKeywordModal.setEditData(params.row);
    },
    addSumit(formValidate) {
      let data = new FormData();
      data.set("keyword", formValidate.keyword);
      data.set("classify_id", formValidate.classify_id);
      data.set("live_id", formValidate.live_id);
      addCommentKeyword(data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.addModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },editSumit(formValidate) {
      let data = new FormData();
      data.set("keyword", formValidate.keyword);
      data.set("classify_id", formValidate.classify_id);
      data.set("live_id", formValidate.live_id);
      editCommentKeyword(data, formValidate.id)
        .then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("成功!");
            this.editModal = false;
            this.handleSearch();
          } else {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$Message.error("失败!");
        });
    },
    cancel() {},
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    handleSearch() {
      this.setTableLoading(true);
      let params = {
        page: this.page,
        pageSize: this.pageSize,
        classify_id: this.classify_id,
        live_id: this.live_id
      };
      getCommentKeywordList(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    handleDelete(params) {
        this.$Modal.confirm({
            title: '提示',
            content: '<p>是否确认删除？</p>',
            onOk: () => {
              deleteCommentKeyword(params.row.id)
                .then((res) => {
                    if (res.data.code == 200) {
                        this.handleSearch()
                        this.$Message.success("成功!");
                    } else {
                        this.$Message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$Message.error("失败!");
                });
            },
            onCancel: () => {
                this.$Message.info('已取消');
            }
        });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
  },
  mounted() {

    getLiveType({}).then((res) => {
        if (res.data.code == 200) {
          var lives = res.data.data;
          var data = new Array()
          for (var i = 0; i < lives.length; i++) {
            data[i] = { id: lives[i].id.toString(), name: lives[i].name }
          }
          this.liveIds = data
          }
      }); 

    getClassifys().then((res) => {
      var classify_list = res.data.data.records;
      var data = new Array()
      for (var i = 0; i < classify_list.length; i++) {
        data[i] = { id: classify_list[i].id.toString(), name: classify_list[i].name }
      }
      this.classifyIds = data
    });

    this.handleSearch();
  },
};
</script>
